var React = require('react');

function Ru (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v160H0z","key":0}),React.createElement("path",{"fill":"#0039a6","d":"M0 160h640v160H0z","key":1}),React.createElement("path",{"fill":"#d52b1e","d":"M0 320h640v160H0z","key":2})]);
}

Ru.defaultProps = {"id":"flag-icons-ru","viewBox":"0 0 640 480"};

module.exports = Ru;

Ru.default = Ru;
